import _defineProperty from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/usr/src/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["type", "replaceHistory", "onClick", "onChange", "className", "children"],
  _excluded2 = ["className", "children"];
var __jsx = React.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Anchor } from 'antd';
import classNames from 'classnames';
import React, { useRef } from 'react';
const DixuAnchor = _ref => {
  let {
      type,
      replaceHistory,
      onClick,
      onChange,
      className,
      children
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  const anchorRef = useRef();
  const classes = classNames('dixu-anchor', {
    [`dixu-anchor--type-${type}`]: type
  }, className);
  const handleOnClick = (event, link) => {
    if (replaceHistory) {
      const {
        href
      } = link;
      window.history.replaceState(null, '', href);
      event.preventDefault();
    }
    onClick?.(event, link);
  };
  const handleOnChange = currentActiveLink => {
    const wrapper = anchorRef.current;
    if (wrapper) {
      const activeLinkElement = wrapper.querySelector(`a[href="${currentActiveLink}"]`);
      if (activeLinkElement) {
        const {
          offsetLeft
        } = activeLinkElement.parentNode || {};
        if (offsetLeft != null) {
          const {
            width
          } = activeLinkElement.parentNode?.getBoundingClientRect() || {};
          const scrollContainer = wrapper.querySelector('.dixu-anchor');
          scrollContainer.scrollLeft = offsetLeft - 0.5 * width;
        }
      }
    }
    onChange?.(currentActiveLink);
  };
  return /*#__PURE__*/React.createElement("div", {
    ref: anchorRef
  }, /*#__PURE__*/React.createElement(Anchor, _objectSpread({
    className: classes,
    onClick: handleOnClick,
    onChange: handleOnChange,
    targetOffset: 160
  }, rest), children));
};
DixuAnchor.defaultProps = {
  type: undefined,
  replaceHistory: false
};
const DixuAnchorLink = _ref2 => {
  let {
      className,
      children
    } = _ref2,
    rest = _objectWithoutProperties(_ref2, _excluded2);
  const classes = classNames('dixu-anchor-link', className);
  return /*#__PURE__*/React.createElement(Anchor.Link, _objectSpread({
    className: classes
  }, rest), children);
};
DixuAnchor.Link = DixuAnchorLink;
export default DixuAnchor;